module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6ba7baed8c9edc87ff698926ff148685.png";